import {
  BarChart, Bar, XAxis, YAxis, Tooltip,
  ResponsiveContainer, CartesianGrid, Legend,
} from "recharts";
import { P, FF } from "../../styles/tokens";
import { fmt, sum } from "../../utils/format";
import { MESES, MESES_CORTO } from "../../constants/months";
import { Card, Pill, Heading, Label, Amount, CustomTooltip } from "../ui";

export default function ComparativaView({ data, activeMonth, mobile }) {
  const prev=activeMonth>0?activeMonth-1:null;
  if(prev===null) return (
    <Card><Heading>📈 Comparativa mes a mes</Heading><p style={{ fontSize:13, color:P.textSm, fontFamily:FF }}>No hay mes anterior para comparar.</p></Card>
  );
  const cur=data[activeMonth], prv=data[prev];
  const metrics=[
    {label:"Ingresos",    cur:sum(cur.ingresos), prv:sum(prv.ingresos), t:P.ingresos, icon:"💵"},
    {label:"Gastos Fijos",cur:sum(cur.fijos),    prv:sum(prv.fijos),    t:P.fijos,    icon:"🏠"},
    {label:"Extras",      cur:sum(cur.extras),   prv:sum(prv.extras),   t:P.extras,   icon:"🛍️"},
    {label:"Ahorro",      cur:sum(cur.ingresos)-sum(cur.fijos)-sum(cur.extras),
                          prv:sum(prv.ingresos)-sum(prv.fijos)-sum(prv.extras), t:P.ahorro, icon:"💰"},
  ];
  const catsCur={},catsPrv={};
  cur.extras.forEach(e=>{if(e.cat) catsCur[e.cat]=(catsCur[e.cat]||0)+(e.monto||0);});
  prv.extras.forEach(e=>{if(e.cat) catsPrv[e.cat]=(catsPrv[e.cat]||0)+(e.monto||0);});
  const allCats=[...new Set([...Object.keys(catsCur),...Object.keys(catsPrv)])];
  const chartData=[
    {mes:MESES_CORTO[prev],...Object.fromEntries(allCats.map(c=>[c,catsPrv[c]||0]))},
    {mes:MESES_CORTO[activeMonth],...Object.fromEntries(allCats.map(c=>[c,catsCur[c]||0]))},
  ];
  const colors=[P.fijos.mid,P.extras.mid,P.ahorro.mid,P.ingresos.mid,"#8B5CF6","#EC4899"];
  return (
    <div style={{ display:"flex", flexDirection:"column", gap:16 }}>
      <Card>
        <Heading>📈 {MESES[prev]} → {MESES[activeMonth]}</Heading>
        <div style={{ display:"grid", gridTemplateColumns:mobile?"1fr 1fr":"repeat(4,1fr)", gap:12 }}>
          {metrics.map(m=>{
            const diff=m.prv>0?((m.cur-m.prv)/m.prv*100):0;
            const up=diff>0;
            const isGoodUp=m.label==="Ingresos"||m.label==="Ahorro";
            const isGood=isGoodUp?up:!up;
            const dt=diff===0?null:isGood?P.ingresos:P.danger;
            return (
              <div key={m.label} style={{ background:P.bg, borderRadius:16, padding:16, border:`1.5px solid ${P.border}` }}>
                <Label>{m.icon} {m.label}</Label>
                <div style={{ margin:"10px 0 4px" }}><Amount size={20} token={m.t}>{fmt(m.cur)}</Amount></div>
                <div style={{ fontSize:11, color:P.textXs, fontFamily:FF, marginBottom:8 }}>antes: {fmt(m.prv)}</div>
                {m.prv>0&&dt&&<Pill label={`${up?"+":""}${diff.toFixed(1)}%`} token={dt} />}
              </div>
            );
          })}
        </div>
      </Card>
      {allCats.length>0&&(
        <Card>
          <Heading>Gastos extras por categoría</Heading>
          <ResponsiveContainer width="100%" height={mobile?180:210}>
            <BarChart data={chartData} barCategoryGap="35%">
              <CartesianGrid strokeDasharray="3 3" stroke={P.border} vertical={false} />
              <XAxis dataKey="mes" tick={{ fontSize:12, fill:P.textSm, fontFamily:FF }} axisLine={false} tickLine={false} />
              <YAxis tick={{ fontSize:10, fill:P.textXs, fontFamily:FF }} axisLine={false} tickLine={false} width={44} tickFormatter={v=>v>=1000?`$${(v/1000).toFixed(0)}k`:`$${v}`} />
              <Tooltip content={<CustomTooltip />} />
              <Legend wrapperStyle={{ fontSize:11, paddingTop:12, fontFamily:FF, color:P.textSm }} />
              {allCats.map((cat,i)=><Bar key={cat} dataKey={cat} fill={colors[i%colors.length]} radius={[6,6,0,0]} />)}
            </BarChart>
          </ResponsiveContainer>
          <div style={{ marginTop:16, display:"flex", flexDirection:"column", gap:8 }}>
            {allCats.map(cat=>{
              const c=catsCur[cat]||0,p2=catsPrv[cat]||0;
              if(!c&&!p2) return null;
              const diff=p2>0?((c-p2)/p2*100):0;
              if(Math.abs(diff)<5&&p2>0) return null;
              const up=diff>0;
              return (
                <div key={cat} style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 14px", borderRadius:14, background:up?P.danger.pastel:P.ingresos.pastel, border:`1.5px solid ${up?P.danger.tint:P.ingresos.tint}` }}>
                  <span>{up?"📈":"📉"}</span>
                  <span style={{ fontSize:13, fontWeight:500, color:up?P.danger.text:P.ingresos.text, fontFamily:FF }}>
                    <strong style={{ fontWeight:800 }}>{cat}</strong>: {up?"subió":"bajó"} {Math.abs(diff).toFixed(0)}% vs {MESES[prev]} ({fmt(p2)} → {fmt(c)})
                  </span>
                </div>
              );
            })}
          </div>
        </Card>
      )}
    </div>
  );
}
